/** [약관] 약관 조회 및 업데이트 */

import { request } from '@/utils/request';
import {
  AgreementCheckParams,
  updateAgreementCheckRequestParam
} from './interface';

/** [약관] 필요 약관 체크 여부 확인 */
export const getAgreementsChecked = async (
  token: string,
  params: AgreementCheckParams
) => {
  const {
    data: { result }
  } = await request(token, 'v2').get('/agreements/check', {
    params
  });
  return result;
};

/** [약관] 필요 약관 불러오기 */
export const getAgreements = async (
  token: string,
  params: AgreementCheckParams
) => {
  const {
    data: { result }
  } = await request(token, 'v2').get('/agreements', { params });

  return result;
};

/** [약관] 약관 상태 업데이트 */
export const updateAgreementsChecked = async (
  token: string,
  body: updateAgreementCheckRequestParam
) => {
  const {
    data: { result }
  } = await request(token, 'v2').post('/agreements', {
    ...body
  });
  return result;
};

export default {
  getAgreementsChecked,
  getAgreements,
  updateAgreementsChecked
};
